import React from 'react';
export const ProjectDefinitionContext = React.createContext(null);
export function useProjectDefinition() {
    const result = React.useContext(ProjectDefinitionContext);
    if (!result) {
        throw new Error(`useProjectDefinition must be used within a <ProjectDefinitionProvider>`);
    }
    return result;
}
//# sourceMappingURL=use-project-definition.js.map